import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { SearchService } from '@services/search.service';
import { GlobalService } from '@common/global';
import { slideInDownOnEnterAnimation, bounceAnimation } from 'angular-animations';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as _ from 'lodash';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
  animations: [
    slideInDownOnEnterAnimation({ anchor: 'slideInDown' }),
    bounceAnimation({ anchor: 'titlebounce', duration: 2000 })
  ]
})
export class HomeComponent implements OnInit {
  latitude: number;
  longitude: number;
  response: any = [];
  titleBounceTrigger = false;
  cat: any = {};
  categoryResponse: any = [];
  appHomeForm: FormGroup;
  images: any = [];
  totalRecord = 0;
  application = "business";
  component = 'b';
  customOptions = {
    loop: true,
    items: 1,
    autoplay: true,
    center: true,
    dots: false,
    autoHeight: true,
    autoWidth: true,
    smartSpeed: 1000,
    autoplayTimeout: 5000
  };
  site_name = "";
  isLoading = false;
  carousel_img_options = { url: true };
  constructor(private router: Router, private fb: FormBuilder, private _searchService: SearchService, private _global: GlobalService) {
   /*  console.log("this._global.getCarouselImage()", this._global.getCarouselImage());
    this.images = this._global.getCarouselImage();
    console.log("this.images", this.images)
    console.log("shuffle", this._global.shuffle(this.images)); */
    this.images =  this._global.shuffle(this._global.getCarouselImage());
    this.site_name = this._global.SITE_NAME;
    this.appHomeForm = this.fb.group({
      category: [],
      location: []
    });
    let p = {
      component: this.component,
      application: this.application,
      sortOrder: 'desc',
      sortString: 'createdTime'
    };
    this._searchService.application(p).subscribe(
      data => {
        this.response = data["response"]["docs"];
        this.totalRecord = this._global.getVal(data, 'response.numFound', '0');
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    let meta = {
      "title": this._global.SITE_TITLE,
      "description": this._global.DESCRIPTION
    };
    this._global.addMetaInfo(meta, '', 'title');

  }

  ngOnInit() {
  // this.setCurrentLocation();
  }
  selectCategory(item) {
    this.router.navigate(['/business'], { queryParams: { category: item.name } });
  }
  public search(result) {
    this.isLoading = true;
    let pa = {
      component: this.component,
      categoryType: 'business',
      application: 'category',
      suggestText: result
    };
    this._searchService.suggest(pa).subscribe(
      data => {
        this.categoryResponse = [];
        this.isLoading = false;
        if (!_.isEmpty(this._global.getVal(data, 'response', []))) {
          let result = this._global.getVal(data, 'response', []);
          Object.entries(result).forEach(([key, value]) => {
            if (value['doc']['categoryType'] == 'business') {
              let base = value['doc']["name"];
              if (value['doc']["base"]) {
                base = value['doc']["base"] + '~' + value['doc']["name"];
              }
              this.categoryResponse.push({ name: value['doc']["name"], id: base });
            }
          });

        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  private setCurrentLocation() {
    console.log("navigator",navigator)
    if ('geolocation' in navigator) {
    console.log("sadsadsa");
      navigator.geolocation.getCurrentPosition((position) => {
        console.log("position",position.coords)
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        console.log("position", this.latitude)
      });
    }
  }
 
}
